// Canonical collection locations from a 100% Metroid Prime: Origins slot save.
// Used to render collected/missing circles; keys match .NUT field names.

export const COLLECTION_CATALOG = {
  missiles: {
    label: "Missile expansions",
    items: [
    {"key":"Missiles Max cho_Burn_Dome_subB x208 y112","room":"cho_Burn_Dome_subB"},
    {"key":"Missiles Max cho_Crossway x16 y48","room":"cho_Crossway"},
    {"key":"Missiles Max cho_Dynamo x224 y32","room":"cho_Dynamo"},
    {"key":"Missiles Max cho_Dynamo x272 y368","room":"cho_Dynamo"},
    {"key":"Missiles Max cho_Furnace_subD x288 y32","room":"cho_Furnace_subD"},
    {"key":"Missiles Max cho_Gathering_Hall x280 y24","room":"cho_Gathering_Hall"},
    {"key":"Missiles Max cho_Hive_Totem x152 y144","room":"cho_Hive_Totem"},
    {"key":"Missiles Max cho_Main_Plaza x120 y520","room":"cho_Main_Plaza"},
    {"key":"Missiles Max cho_Main_Plaza x584 y456","room":"cho_Main_Plaza"},
    {"key":"Missiles Max cho_Main_Plaza x64 y80","room":"cho_Main_Plaza"},
    {"key":"Missiles Max cho_Ruined_Fountain x576 y160","room":"cho_Ruined_Fountain"},
    {"key":"Missiles Max cho_Ruined_Gallery x48 y336","room":"cho_Ruined_Gallery"},
    {"key":"Missiles Max cho_Ruined_Gallery x592 y248","room":"cho_Ruined_Gallery"},
    {"key":"Missiles Max cho_Ruined_Nursery x352 y320","room":"cho_Ruined_Nursery"},
    {"key":"Missiles Max cho_Ruined_Shrine x272 y32","room":"cho_Ruined_Shrine"},
    {"key":"Missiles Max cho_Ruined_Shrine x904 y168","room":"cho_Ruined_Shrine"},
    {"key":"Missiles Max cho_Training_Chamber_Access x288 y144","room":"cho_Training_Chamber_Access"},
    {"key":"Missiles Max cho_Vault x192 y112","room":"cho_Vault"},
    {"key":"Missiles Max cho_Watery_Hall x560 y288","room":"cho_Watery_Hall"},
    {"key":"Missiles Max cho_Watery_Hall_Access x151 y135","room":"cho_Watery_Hall_Access"},
    {"key":"Missiles Max mag_Fiery_Shores x48 y64","room":"mag_Fiery_Shores"},
    {"key":"Missiles Max mag_Storage_Cavern x48 y80","room":"mag_Storage_Cavern"},
    {"key":"Missiles Max mag_Triclops_Pit x512 y64","room":"mag_Triclops_Pit"},
    {"key":"Missiles Max pha_Elite_Control_Access x224 y48","room":"pha_Elite_Control_Access"},
    {"key":"Missiles Max pha_Elite_Research_subB x128 y32","room":"pha_Elite_Research_subB"},
    {"key":"Missiles Max pha_Fungal_Hall_Access x208 y400","room":"pha_Fungal_Hall_Access"},
    {"key":"Missiles Max pha_Fungal_Hall_B x912 y240","room":"pha_Fungal_Hall_B"},
    {"key":"Missiles Max pha_Main_Quarry x592 y48","room":"pha_Main_Quarry"},
    {"key":"Missiles Max pha_Metroid_Quarantine_A x512 y48","room":"pha_Metroid_Quarantine_A"},
    {"key":"Missiles Max pha_Metroid_Quarantine_B x888 y304","room":"pha_Metroid_Quarantine_B"},
    {"key":"Missiles Max pha_Phazon_Processing_Center x568 y632","room":"pha_Phazon_Processing_Center"},
    {"key":"Missiles Max pha_Security_Access_A x192 y176","room":"pha_Security_Access_A"},
    {"key":"Missiles Max phe_Frost_Cave x296 y392","room":"phe_Frost_Cave"},
    {"key":"Missiles Max phe_Gravity_Chamber_subB x56 y32","room":"phe_Gravity_Chamber_subB"},
    {"key":"Missiles Max phe_Ice_Ruins_East x16 y32","room":"phe_Ice_Ruins_East"},
    {"key":"Missiles Max phe_Ice_Ruins_East x368 y256","room":"phe_Ice_Ruins_East"},
    {"key":"Missiles Max phe_Phendrana_Shorelines_subB x112 y832","room":"phe_Phendrana_Shorelines_subB"},
    {"key":"Missiles Max phe_Phendrana_Shorelines_subB x544 y256","room":"phe_Phendrana_Shorelines_subB"},
    {"key":"Missiles Max phe_Quarantine_Monitor x184 y128","room":"phe_Quarantine_Monitor"},
    {"key":"Missiles Max phe_Research_Lab_Aether x352 y192","room":"phe_Research_Lab_Aether"},
    {"key":"Missiles Max phe_Research_Lab_Hydra_subB x376 y160","room":"phe_Research_Lab_Hydra_subB"},
    {"key":"Missiles Max tal_Arbor_Chamber x144 y80","room":"tal_Arbor_Chamber"},
    {"key":"Missiles Max tal_Biohazard_Containment x265 y384","room":"tal_Biohazard_Containment"},
    {"key":"Missiles Max tal_Crash_Site x616 y296","room":"tal_Crash_Site"},
    {"key":"Missiles Max tal_Great_Tree_Chamber x152 y136","room":"tal_Great_Tree_Chamber"},
    {"key":"Missiles Max tal_Landing_Site x800 y528","room":"tal_Landing_Site"},
    {"key":"Missiles Max tal_Life_Grove_Tunnel x304 y96","room":"tal_Life_Grove_Tunnel"},
    {"key":"Missiles Max tal_Overgrown_Cavern x144 y128","room":"tal_Overgrown_Cavern"},
    {"key":"Missiles Max tal_Root_Cave x48 y208","room":"tal_Root_Cave"},
    {"key":"Missiles Max tal_Transport_Tunnel_B x152 y160","room":"tal_Transport_Tunnel_B"}
    ],
  },
  "energy-tanks": {
    label: "Energy tanks",
    items: [
    {"key":"Energy Tanks Max cho_Furnace_subC x160 y112","room":"cho_Furnace_subC"},
    {"key":"Energy Tanks Max cho_Hall_of_the_Elders x384 y32","room":"cho_Hall_of_the_Elders"},
    {"key":"Energy Tanks Max cho_Main_Plaza x104 y256","room":"cho_Main_Plaza"},
    {"key":"Energy Tanks Max cho_Training_Chamber x392 y72","room":"cho_Training_Chamber"},
    {"key":"Energy Tanks Max cho_Transport_Access_North x152 y134","room":"cho_Transport_Access_North"},
    {"key":"Energy Tanks Max mag_Magmoor_Workstation x568 y377","room":"mag_Magmoor_Workstation"},
    {"key":"Energy Tanks Max mag_Transport_Tunnel_A x160 y48","room":"mag_Transport_Tunnel_A"},
    {"key":"Energy Tanks Max pha_Processing_Center_Access x72 y120","room":"pha_Processing_Center_Access"},
    {"key":"Energy Tanks Max pha_Ventilation_Shaft x152 y352","room":"pha_Ventilation_Shaft"},
    {"key":"Energy Tanks Max phe_Research_Lab_Aether_subB x169 y144","room":"phe_Research_Lab_Aether_subB"},
    {"key":"Energy Tanks Max phe_Ruined_Courtyard x16 y400","room":"phe_Ruined_Courtyard"},
    {"key":"Energy Tanks Max phe_Transport_Access x160 y160","room":"phe_Transport_Access"},
    {"key":"Energy Tanks Max tal_Cargo_Freight_Lift_to_Deck_Gamma x233 y124","room":"tal_Cargo_Freight_Lift_to_Deck_Gamma"},
    {"key":"Energy Tanks Max tal_Hydro_Access_Tunnel x576 y144","room":"tal_Hydro_Access_Tunnel"}
    ],
  },
  "power-bombs": {
    label: "Power bomb expansions",
    items: [
    {"key":"Power Bombs Max cho_Magma_Pool x584 y168","room":"cho_Magma_Pool"},
    {"key":"Power Bombs Max mag_Fiery_Shores x576 y32","room":"mag_Fiery_Shores"},
    {"key":"Power Bombs Max pha_Central_Dynamo x312 y296","room":"pha_Central_Dynamo"},
    {"key":"Power Bombs Max phe_Ice_Ruins_West x360 y248","room":"phe_Ice_Ruins_West"},
    {"key":"Power Bombs Max phe_Security_Cave x168 y120","room":"phe_Security_Cave"}
    ],
  },
  artifacts: {
    label: "Artifacts",
    // Names match the Chozo Artifacts array order (Artifact 1 = Truth, …).
    items: [
    {"n":1,"name":"Truth","flag":"Artifact 1","key":"Artifact 1 tal_Cipher_Site x288 y371","room":"tal_Cipher_Site"},
    {"n":2,"name":"Strength","flag":"Artifact 2","key":"Artifact 2 mag_Warrior_Shrine x112 y64","room":"mag_Warrior_Shrine"},
    {"n":3,"name":"Elder","flag":"Artifact 3","key":"Artifact 3 phe_Control_Tower_subC x240 y128","room":"phe_Control_Tower_subC"},
    {"n":4,"name":"Wild","flag":"Artifact 4","key":"Artifact 4 cho_Sunchamber x320 y224","room":"cho_Sunchamber"},
    {"n":5,"name":"Lifegiver","flag":"Artifact 5","key":"Artifact 5 cho_Tower_Chamber x160 y112","room":"cho_Tower_Chamber"},
    {"n":6,"name":"Chozo","flag":"Artifact 6","key":"Artifact 6 pha_Elite_Research x112 y96","room":"pha_Elite_Research"},
    {"n":7,"name":"Warrior","flag":"Artifact 7","key":"Artifact 7 tal_Life_Grove x488 y320","room":"tal_Life_Grove"},
    {"n":8,"name":"Nature","flag":"Artifact 8","key":"Artifact 8 mag_Lava_Lake_subC x274 y78","room":"mag_Lava_Lake_subC"},
    {"n":9,"name":"Sun","flag":"Artifact 9","key":"Artifact 9 phe_Chozo_Ice_Temple_subD x168 y152","room":"phe_Chozo_Ice_Temple_subD"},
    {"n":10,"name":"World","flag":"Artifact 10","key":"Artifact 10 cho_Elder_Chamber x152 y72","room":"cho_Elder_Chamber"},
    {"n":11,"name":"Spirit","flag":"Artifact 11","key":"Artifact 11 phe_Storage_Cave x184 y120","room":"phe_Storage_Cave"},
    {"n":12,"name":"Newborn","flag":"Artifact 12","key":"Artifact 12 pha_Phazon_Mining_Tunnel x104 y347","room":"pha_Phazon_Mining_Tunnel"}
    ],
  },
}
